export default "__VITE_PUBLIC_ASSET__c3e8d10d__"